import React, { useCallback, useState } from 'react';
import Button from './Button';
import { Spin } from 'antd';
const LoadingButton = ({ onClick, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onClickHandler = useCallback(() => {
        setIsLoading(true);
        onClick()
            .finally(() => setIsLoading(false));
    }, [onClick]);
    return (<span>
      <Spin spinning={isLoading}>
        <Button {...props} onClick={onClickHandler}/>
      </Spin>
    </span>);
};
export default LoadingButton;
